export default (where: string, error: Error) =>
  console.log(`${where} :`, error.message);
